const INVITATION_PATH = /\/join\/[^/?#\s]+/gi;
const ENCODED_INVITATION_PATH = /%2fjoin%2f[^&\s]+/gi;

export const redactSensitiveUrl = (value) => {
  if (value === null || value === undefined) return value;
  return String(value)
    .replace(INVITATION_PATH, '/join/[redacted]')
    .replace(ENCODED_INVITATION_PATH, '%2Fjoin%2F[redacted]');
};
